import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Home from 'routes/home';
import Skyw from 'routes/skyw';
import OWLNetNow from 'routes/owlnet-now';
import Forecast from 'routes/forecast';
import ForecastIframe from 'routes/forecast/iframe';
import ForecastDev from 'routes/forecast/dev';
import Display from 'routes/display/Display';
import GUI from 'routes/display/GUI';
import Simulator from 'routes/simulator';

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/display" element={<Display />}></Route>
        <Route path="/simulator" element={<Simulator />}></Route>
        <Route path="/gui" element={<GUI />}></Route>
        <Route path="/now" element={<OWLNetNow />}></Route>
        <Route path="/forecast" element={<Forecast />}></Route>
        <Route path="/forecast-iframe" element={<ForecastIframe />}></Route>
        <Route path="/forecast-dev" element={<ForecastDev />}></Route>
        <Route path="/owlmng_songino" element={<Skyw title="SONGINO" obsId={1} />}></Route>
        <Route path="/owlmar_oukaimeden" element={<Skyw title="OUKAIMEDEN" obsId={2} />}></Route>
        <Route path="/owlisr_mitzperamon" element={<Skyw title="MITZPERAMON" obsId={3} />}></Route>
        <Route path="/owlusa_lemmon" element={<Skyw title="LEMMON" obsId={4} />}></Route>
        <Route path="/owlkor_bohyun" element={<Skyw title="BOHYUN" obsId={5} />}></Route>
        <Route path="/owltb_daedeok" element={<Skyw title="DAEDEOK" obsId={0} />}></Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
